// import { GetAprsResponse, EmptyRequest } from "../proto/provernet_pb";
// import { ProverNetServerClient } from "../proto/ProvernetServiceClientPb";

// const client = new ProverNetServerClient(
//   "https://35.91.204.196:13082",
//   null,
//   null
// );

// export const getAprs = (request: EmptyRequest): Promise<GetAprsResponse> => {
//   return client.getAprs(request, {
//     "Cache-Control": "no-cache",
//   });
// };

export async function getAprs() {
  const res = await fetch(
    "https://incentra-prd.brevis.network/provenet/v1/getaprs"
  );
  return res.json();
}
